/* ============================================================================
   Curated Collection JS  —  v2025-08-02-FIXED
============================================================================ */

(() => {
  const GRID_SEL = 'ul#product-grid, ul[id^="product-grid"], .product-grid';
  
  // 0. Parse URL
  const qp = new URLSearchParams(location.search);
  let rawFirst = decodeURIComponent((qp.get('first') || '').trim());
  let firstHandle = '';
  let variantFromURL = '';

  if (rawFirst.startsWith('http')) {
    try {
      const u = new URL(rawFirst);
      const segs = u.pathname.split('/').filter(Boolean);
      if (segs[0] === 'products' && segs[1]) firstHandle = segs[1];
      variantFromURL = u.searchParams.get('variant') || '';
    } catch (e) { console.error('URL parse error:', e); }
  } else {
    const segs = rawFirst.split('/').filter(Boolean);
    firstHandle = segs.pop();
  }
  
  if (!firstHandle) return;

  const variantID = (/^\d+$/.test(qp.get('variant') || variantFromURL))
    ? (qp.get('variant') || variantFromURL)
    : '';

  let source = (qp.get('source') || '').trim();
  if (!source) {
    const p = location.pathname.split('/').filter(Boolean);
    if (p[0] === 'collections' && p[1]) source = p[1];
  }
  if (!source) return;

  const limit = Math.max(1, parseInt(qp.get('limit') || '24', 10));
  const grid = document.querySelector(GRID_SEL);
  if (!grid) return;

  // 1. Helpers
  const previewExtras = (() => {
    const list = [];
    ['preview_theme_id', 'preview_theme_token', 'pb'].forEach(k => {
      if (qp.has(k)) list.push(`${k}=${encodeURIComponent(qp.get(k) || '')}`);
    });
    return list.join('&');
  })();
  
  const appendPreview = url =>
    previewExtras ? (url.includes('?') ? `${url}&${previewExtras}` : `${url}?${previewExtras}`) : url;
  const needsCookie = Boolean(previewExtras);

  const aspect = (grid.getAttribute('data-aspect') || '').toLowerCase();
  const view = aspect === 'square' ? 'card-square' : aspect === 'portrait' ? 'card-portrait' : 'card';

  const cacheKey = (h, v) => `card:${view}:${h}:${v||'noVar'}`;
  const getCache = (h, v) => { try { return sessionStorage.getItem(cacheKey(h, v)); } catch (e) { return null; } };
  const setCache = (h, v, html) => { try { sessionStorage.setItem(cacheKey(h, v), html); } catch (e) {} };

  const fetchCard = async (handle, variant='') => {
    try {
      const cached = getCache(handle, variant);
      if (cached) return cached;

      const url = appendPreview(`/products/${encodeURIComponent(handle)}?view=${view}${variant ? `&variant=${variant}` : ''}`);
      const r = await fetch(url, { credentials: needsCookie ? 'same-origin' : 'omit', cache: 'force-cache' });
      if (!r.ok) return '';
      
      const html = await r.text();
      // Nếu HTML trả về là trang 404 mặc định hoặc rỗng
      if (html.includes('404') && html.includes('Page not found')) return ''; 
      
      if (html.trim()) setCache(handle, variant, html);
      return html;
    } catch (e) {
      console.error(`Fetch card failed for ${handle}:`, e);
      return '';
    }
  };

  const render = html => { if (html && html.trim()) grid.insertAdjacentHTML('beforeend', html); };
  const updateCount = () => {
    const c = grid.querySelectorAll('.grid__item').length;
    document.querySelectorAll('[data-product-count], .product-count, .collection-product-count')
      .forEach(el => el.textContent = `${c} Products`);
  };

  // 2. Main Logic
  grid.innerHTML = '<li class="grid__item">Loading...</li>';

  const pinnedPromise = fetchCard(firstHandle, variantID);
  
  // Fetch handles list safely
  const handlesPromise = fetch(appendPreview(`/collections/${encodeURIComponent(source)}?view=handles.json`), { 
      credentials: needsCookie ? 'same-origin' : 'omit', 
      cache: 'force-cache' 
    })
    .then(r => {
      if (!r.ok) throw new Error(`Collection fetch failed: ${r.status}`);
      return r.text(); // Lấy text trước để kiểm tra có phải HTML không
    })
    .then(text => {
      try {
        return JSON.parse(text);
      } catch (e) {
        console.error('JSON Parse Error. Content received:', text.substring(0, 100));
        return { handles: [] };
      }
    })
    .catch(e => {
      console.error('Handles fetch error:', e);
      return { handles: [] };
    });

  (async () => {
    try {
      // 4-a Render pinned
      const pinnedHTML = await pinnedPromise;
      grid.innerHTML = ''; // Clear loading
      
      if (pinnedHTML) {
        render(pinnedHTML);
      } else {
        console.warn('Pinned product HTML is empty. Check handle:', firstHandle);
      }

      // 4-b Render rest
      const data = await handlesPromise;
      const raw = (data && Array.isArray(data.handles)) ? data.handles : [];
      
      const seen = new Set([firstHandle]);
      const restHandles = [];
      
      // Calculate remaining slots
      const limitVal = limit - (pinnedHTML ? 1 : 0);
      
      for (const h of raw) {
        if (h && !seen.has(h)) { seen.add(h); restHandles.push(h); }
        if (restHandles.length >= limitVal) break;
      }

      const cards = await Promise.all(restHandles.map(h => fetchCard(h)));
      cards.forEach(render);
      updateCount();

      // 4-c Swap Variant Image
      if (variantID && pinnedHTML) {
        try {
          const prodUrl = `/products/${firstHandle}.js`;
          const prod = await fetch(prodUrl).then(r => r.json());
          const varObj = prod.variants.find(v => String(v.id) === variantID);
          
          if (varObj && varObj.featured_image) {
            const newSrcBase = varObj.featured_image.src;
            const pinnedLi = grid.querySelector('li.grid__item:first-child'); // Lấy thẻ đầu tiên
            if (pinnedLi) {
               pinnedLi.querySelectorAll('img').forEach(img => {
                const m = img.src.match(/_(\d+x)\./);
                // Fix: thay thế chính xác phần mở rộng file
                const sized = m ? newSrcBase.replace(/(\.[^.]*)$/, `_${m[1]}$1`) : newSrcBase;
                img.src = sized;
                img.srcset = ''; 
              });
              
              pinnedLi.querySelectorAll('a[href*="/products/"]').forEach(a => {
                const u = new URL(a.href, location.origin);
                u.searchParams.set('variant', variantID);
                a.href = u.pathname + u.search;
              });
            }
          }
        } catch (e) { console.warn('Variant swap failed:', e); }
      }
    } catch (err) {
      throw err; // Ném lỗi ra ngoài để catch block dưới cùng bắt được
    }
  })().catch((e) => {
    console.error('CRITICAL SCRIPT ERROR:', e);
    grid.innerHTML = `<li class="grid__item">Error: ${e.message}. Check Console (F12) for details.</li>`;
  });
})();